import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2026-03-13 15:47:48 +0100 (Fri, 13 Mar 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 161511 $
//  Purpose   : job wiki templates
// =============================================================================
// ---Third-party imports
import React, { useState } from 'react';
// ---Framework imports
import log from 'uix/logging';
import { keys, dict, filterItems } from 'ldash';
import { TagMatcher } from 'uix/wiki/utils';
import { HeaderSegment } from 'uix/components';
// ---Local imports
import { JobWikiButton, JobMenuButton, JobTable } from './components';
import { useJobFilterApi } from './hooks';
import styles from './styles.css';
import { jobsIcon } from './utils';
// ---Exports
let extractParams = (attrib, ...exclude)=>{
    return dict(filterItems(attrib, (name, value)=>!exclude.includes(name)));
};
const completion = (tag_name)=>({ jobSpec })=>{
        if (jobSpec) {
            let names = keys(jobSpec);
            return {
                '!top': [
                    tag_name
                ],
                [tag_name]: {
                    attrs: {
                        name: names,
                        confirm: [
                            'true',
                            'false'
                        ]
                    }
                }
            };
        }
    };
const button_props = (attrib)=>({
        name: attrib.name,
        confirm: attrib.confirm === '' || attrib.confirm !== 'false',
        params: extractParams(attrib, 'name', 'confirm')
    });
export const Job = {
    match: ({ tag })=>tag == 'Job',
    build: ({ attrib })=>/*#__PURE__*/ _jsx(JobWikiButton, {
            ...button_props(attrib)
        }),
    completion: completion('Job')
};
export const xmenu_jobbutton = {
    match: ({ tag })=>tag == 'XMenu.Job',
    build: ({ attrib })=>/*#__PURE__*/ _jsx(JobMenuButton, {
            ...button_props(attrib)
        }),
    completion: completion('XMenu.Job')
};
export const JobTableMatcher = TagMatcher('JobTable', ({ names, days, numrows })=>{
    numrows = parseInt(numrows) || 8;
    days = parseInt(days) || 7;
    let { jobs, loading } = useJobFilterApi({
        names,
        days
    });
    let menu = null;
    return /*#__PURE__*/ _jsx(HeaderSegment, {
        basic: true,
        header: "Jobs",
        loading: loading,
        icon: jobsIcon('eye'),
        menu: menu,
        children: /*#__PURE__*/ _jsx(JobTable, {
            compact: true,
            flat: true,
            jobs: jobs,
            pageSize: numrows
        })
    });
}, {
    names: [
        'import'
    ],
    days: [
        '7'
    ],
    numrows: [
        '8'
    ]
}, 'List jobs in table form');
